import styled from 'styled-components';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const ScrollContainer = styled.div`
	height: 100%;
	overflow: auto;
`;

export const Content = styled.div`
	height: 100%;
	overflow: hidden;
`;

export const InfoText = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 0 auto;
	font-size: 19px;
`;

export const LoaderWrapper = styled.div`
	flex: 1;
	display: flex;
`;
